module.exports = __webpack_public_path__ + "static/img/promotional_1.fe632f21.png";